/* external-links.js — open non-Shop links in a new tab.
   Deferred. Covers rich text, blog and page content, and links apps add later.
   Theme menus and editor URLs are also marked in Liquid. No visual change. */
(function (global) {
  'use strict';

  var BLOCKED = ['/cart', '/checkout', '/checkouts', '/apps', '/account', '/authentication'];
  var BUILTIN_HOSTS = ['shop.prageru.com', 'prageru.myshopify.com'];
  var APP_SELECTOR = [
    'shopify-accelerated-checkout',
    'shopify-accelerated-checkout-cart',
    'shopify-paypal-button',
    'shopify-apple-pay-button',
    'shopify-google-pay-button',
    'shopify-shop-pay-button',
    '.shopify-payment-button',
    '.shopify-challenge__container',
    'shopify-account'
  ].join(',');

  function hostKey(value) {
    return String(value || '').trim().toLowerCase().replace(/\.$/, '');
  }

  function stripRoot(pathname, root) {
    var path = pathname || '/';
    var prefix = root || '/';
    if (prefix.length > 1) {
      if (prefix.charAt(prefix.length - 1) === '/') prefix = prefix.slice(0, -1);
      if (path === prefix) return '/';
      if (path.indexOf(prefix + '/') === 0) path = path.slice(prefix.length) || '/';
    }
    var parts = path.split('/');
    if (parts.length > 2 && /^[a-z]{2}(?:-[a-z0-9]{2,8})?$/i.test(parts[1])) {
      path = '/' + parts.slice(2).join('/');
    }
    if (path.length > 1 && path.charAt(path.length - 1) === '/') path = path.slice(0, -1);
    return (path || '/').toLowerCase();
  }

  function excludedPath(pathname) {
    var path = pathname || '/';
    var i;
    for (i = 0; i < BLOCKED.length; i++) {
      var block = BLOCKED[i];
      if (path === block || path.indexOf(block + '/') === 0) return true;
    }
    return false;
  }

  /* Cart, checkout, account, and /apps stay in this tab only on the Shop
     and on shopify.com. The same path on www.prageru.com or any other host
     is a normal external link. */
  function pathExclusionHost(host) {
    if (host === 'shop.prageru.com' || host === 'prageru.myshopify.com') return true;
    if (host === 'shopify.com') return true;
    return host.length > 12 && host.slice(-12) === '.shopify.com';
  }

  function mergeRel(rel) {
    var parts = String(rel || '').split(/\s+/);
    var next = [];
    var has = false;
    var i;
    for (i = 0; i < parts.length; i++) {
      if (!parts[i]) continue;
      next.push(parts[i]);
      if (parts[i].toLowerCase() === 'noopener') has = true;
    }
    if (!has) next.push('noopener');
    return next.join(' ');
  }

  /**
   * True when this href should open in a new tab.
   * options.base is the page URL. options.shopHosts includes the Shop hosts.
   * options.root is Shopify.routes.root. options.target / sameTab / insideApp
   * mirror attributes and checkout or account app containers.
   */
  function shouldOpen(href, options) {
    var opts = options || {};
    if (opts.sameTab || opts.insideApp || opts.download) return false;
    if (opts.target && String(opts.target).trim()) return false;
    var raw = String(href || '').trim();
    if (!raw) return false;
    var lower = raw.toLowerCase();
    if (lower.charAt(0) === '#') return false;
    if (lower.indexOf('mailto:') === 0 || lower.indexOf('tel:') === 0 || lower.indexOf('sms:') === 0 || lower.indexOf('javascript:') === 0) return false;

    var url;
    try {
      url = new URL(raw, opts.base || 'https://shop.prageru.com/');
    } catch (e) {
      return false;
    }
    if (url.protocol !== 'http:' && url.protocol !== 'https:') return false;

    var host = hostKey(url.hostname);
    if (!host) return false;
    var shops = opts.shopHosts || BUILTIN_HOSTS;
    var s;
    for (s = 0; s < shops.length; s++) {
      if (host === hostKey(shops[s])) return false;
    }
    if (host === 'accounts.shopify.com' || host === 'checkout.shopify.com') return false;

    var path = stripRoot(url.pathname, opts.root || '/');
    if (pathExclusionHost(host) && excludedPath(path)) return false;
    if ((host === 'shopify.com' || host === 'www.shopify.com') && /^\/\d+\/account(?:\/|$)/.test(path)) return false;
    return true;
  }

  function readHosts(script, pageHost) {
    var hosts = BUILTIN_HOSTS.slice();
    var raw = script && script.getAttribute ? script.getAttribute('data-shop-hosts') : '';
    var parts = String(raw || '').split(',');
    var i;
    for (i = 0; i < parts.length; i++) {
      var host = hostKey(parts[i]);
      if (host && hosts.indexOf(host) === -1) hosts.push(host);
    }
    var page = hostKey(pageHost);
    if (page && hosts.indexOf(page) === -1) hosts.push(page);
    return hosts;
  }

  function boot(doc, loc, script) {
    if (!doc || !doc.body || !loc) return;
    var pageHost = hostKey(loc.hostname);
    if (pageHost === 'accounts.shopify.com' || pageHost === 'checkout.shopify.com') return;
    if (global.Shopify && global.Shopify.Checkout) return;

    var shopHosts = readHosts(script, pageHost);
    var root = (global.Shopify && global.Shopify.routes && global.Shopify.routes.root) || '/';
    var seen = typeof WeakSet === 'function' ? new WeakSet() : null;

    function insideApp(anchor) {
      if (!anchor.closest) return false;
      try {
        return !!anchor.closest(APP_SELECTOR);
      } catch (e) {
        return false;
      }
    }

    function consider(anchor) {
      if (!anchor || !anchor.getAttribute || !anchor.tagName) return;
      if (anchor.tagName.toUpperCase() !== 'A') return;
      if (seen && seen.has(anchor)) return;
      var href = anchor.getAttribute('href');
      if (!href) return;
      if (seen) seen.add(anchor);
      var open = shouldOpen(href, {
        base: loc.href,
        shopHosts: shopHosts,
        root: root,
        target: anchor.getAttribute('target'),
        sameTab: anchor.hasAttribute && anchor.hasAttribute('data-same-tab'),
        download: anchor.hasAttribute && anchor.hasAttribute('download'),
        insideApp: insideApp(anchor)
      });
      if (!open) return;
      anchor.setAttribute('rel', mergeRel(anchor.getAttribute('rel')));
      anchor.setAttribute('target', '_blank');
    }

    function scan(node) {
      if (!node) return;
      if (node.nodeType === 1) {
        consider(node);
        if (!node.querySelectorAll) return;
        var links = node.querySelectorAll('a[href]');
        var i;
        for (i = 0; i < links.length; i++) consider(links[i]);
        return;
      }
      if (node.nodeType === 11 && node.querySelectorAll) {
        var fragLinks = node.querySelectorAll('a[href]');
        var j;
        for (j = 0; j < fragLinks.length; j++) consider(fragLinks[j]);
      }
    }

    scan(doc.body);
    if (typeof MutationObserver !== 'function') return;
    var observer = new MutationObserver(function (mutations) {
      var i;
      var j;
      for (i = 0; i < mutations.length; i++) {
        var added = mutations[i].addedNodes;
        for (j = 0; j < added.length; j++) scan(added[j]);
      }
    });
    observer.observe(doc.body, { childList: true, subtree: true });
  }

  var api = {
    shouldOpen: shouldOpen,
    mergeRel: mergeRel,
    stripRoot: stripRoot,
    boot: boot
  };

  if (typeof module === 'object' && module.exports) {
    module.exports = api;
  }

  if (!global || !global.document) return;

  var scriptEl = global.document.currentScript;
  function start() {
    boot(global.document, global.location, scriptEl);
  }
  if (global.document.readyState === 'loading' || global.document.readyState === 'interactive') {
    global.document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})(typeof window !== 'undefined' ? window : globalThis);
